import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllInventoryLevelEventsDataGrid } from "src/components/views/erp/warehouse/inventory/AllInventoryLevelEventsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/inventory/allInventoryLevelEvents")({
	staticData: { title: i18n.t("inventory_level_events"), legacyViewKey: "allInventoryLevelEventsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllInventoryLevelEventsDataGrid />;
}
